import $ from "jquery";
import 'jquery-validation';
import 'owl.carousel';
import Swal from 'sweetalert2'

$(document).ready(function(){
  const urlParams = new URLSearchParams(window.location.search);
    let formRegisterPMO = $('#registerForm')
    const option = {
      rules: {
        "name": {
          required: true,
          maxlength: 255
        },
        "phone": {
          required: true,
          maxlength: 20
        },
        "email": {
          required: true,
          email: true
        },
        "course": {
          required: true,
          number: true,
        },
      },
      messages: {
        "name": {
          required: "Vui lòng nhập họ tên",
          maxlength: "Họ tên không hợp lệ"
        },
        "email": {
          required: "Vui lòng nhập nhập email",
          email: "Email không hợp lệ"
        },
        "phone": {
          required: "Vui lòng nhập nhập số điện thoại",
          maxlength: "Số điện thoại không hợp lệ"
        },
        "course": {
          required: "Vui lòng chọn khóa học",
        },
      },
      submitHandler: function () {
        let url = $('.btn-register').data('url');
        let data = {
          'name': formRegisterPMO.find('input[name="name"]').val(),
          'phone': formRegisterPMO.find('input[name="phone"]').val(),
          'email': formRegisterPMO.find('input[name="email"]').val(),
          'course': formRegisterPMO.find('select[name="course"]').val(),
          'source':  urlParams.get('source') 
        };
        $.ajax({
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data: data,
          type: "POST",
          url: url,
          success: function (response) {
            if (response.status == true) {
                formRegisterPMO.find('input').val("");
                formRegisterPMO.find('textarea').val("");
                formRegisterPMO.find('option:selected').remove();
                formRegisterPMO.find('.alert-success').show();
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Đăng ký thành công',
                showConfirmButton: false,
                timer: 2000
              })
            }
          },
        });
      }
    }
    formRegisterPMO.validate(option);
    $(document).on('click', '.btn-register', function () {
      formRegisterPMO.find('.alert-success').hide();
    });
})


function initSlideListFeedBack() {
  var slideList = $('.testimonial');
  if ($(window).width() ) {
    slideList.owlCarousel({
      items: 1,
      center: false,
      loop: true,
      margin: 20,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true,
      responsiveClass:true,
      dots: true,
      responsive: {
        550: {
          items: 2
        },
        850: {
            items: 3
          }
      },
    });
  } else {
    slideList.owlCarousel('destroy');
  }
}

$(window).resize(function () {
  initSlideListFeedBack();
});

$(document).ready(function () {
  initSlideListFeedBack();

  $('.register-button').on('click', function (e) {
    e.preventDefault();
    $(".register-consultation").get(0).scrollIntoView({ behavior: 'smooth' });
  })
});